import { render } from "./BaseOverlay.vue?vue&type=template&id=0b5bf002"
import script from "./BaseOverlay.vue?vue&type=script&lang=js"
export * from "./BaseOverlay.vue?vue&type=script&lang=js"

import "./BaseOverlay.vue?vue&type=style&index=0&id=0b5bf002&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__